export const ACCENT = "#185FA5";
export const ACCENT_DARK = "#0F3D6B";
export const CANVAS_BG = "#E9EDF2";

// Page size is locked to A4 — no other sizes are offered.
export const A4 = { label: "A4", w: 794, h: 1123, mmW: 210, mmH: 297 };

export const PX_PER_MM = 96 / 25.4;

// Default inner page margin (px, unscaled). Used as the printable-area
// boundary — shown as a guide box, snap target, and the reference for the
// "Align on page" quick actions.
export const DEFAULT_MARGIN = { top: 40, right: 40, bottom: 40, left: 40 };

export const THUMB_W = 96;

export const ELEMENT_DEFAULTS = {
  text: () => ({
    w: 240,
    h: 36,
    content: "Double-click to edit text",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: "normal",
    textDecoration: "none",
    color: "#1f2937",
    align: "left",
  }),
  heading: () => ({
    w: 320,
    h: 44,
    content: "Heading",
    fontSize: 24,
    fontWeight: 700,
    fontStyle: "normal",
    textDecoration: "none",
    color: ACCENT,
    align: "left",
  }),
  table: () => ({
    w: 420,
    h: 140,
    fontSize: 12,
    rows: [
      ["Description", "Qty", "Rate", "Amount"],
      ["Item 1", "1", "0.00", "0.00"],
      ["Item 2", "1", "0.00", "0.00"],
    ],
  }),
  line: () => ({ w: 220, h: 3, color: ACCENT }),
  rect: () => ({ w: 220, h: 100, color: "#F5F7FA", borderColor: "#D0D7E2" }),
  image: () => ({ w: 160, h: 100, src: "" }),
};